/* global Blockly */

import React from 'react';
import PropTypes from 'prop-types';
import MobiControlCore from '../../../v1/blocks/MobiControl/MobiControlCore';

function defineBlock(context) {
    const prop = { ...context };
    prop.blockText = 'is MC user logged in';
    prop.tooltipText = 'Check whether a MobiControl user is logged in.';
    prop.responseText = 'is logged in';
    prop.responseBlockType = 'boolean_response';

    return MobiControlCore(prop);
}

function defineGenerators() {
    return {
        JavaScript: function (block) {
            const coreResponseCode = block.getJavascriptCore();
            return `Snap.mcLockdown.user.isLoggedIn(${coreResponseCode});\n`;
        }
    };
}

const MobiControlIsUserLoggedIn = function (props) {
    const name = 'snap_mobicontrol_isuserloggedin';
    MobiControlIsUserLoggedIn.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    const generators = defineGenerators();
    for (const language in generators) {
        Blockly[language][name] = generators[language];
    }

    return <block type={name}></block>;
};

MobiControlIsUserLoggedIn.propTypes = {
    context: PropTypes.object
};

export default MobiControlIsUserLoggedIn;
